export default __webpack_public_path__ + "static/media/caroussel-2.759f7add.png";